export interface IContactPhone {
  phoneNumber?: number;
  countryCode?: number;
}
